import FootballStatsCollection from "./football-stats-collection";
import FootballStatsCategory from "./football-stats-category";
import { getSafeOrDefault } from "../../../services/common/object-util";

export default class FootballDriveStatsCollection extends FootballStatsCollection {
    constructor(drive, gameContext = {}, statLogs = []) {
        super(
            statLogs.filter((s) => {
                return s.driveId === drive.id;
            })
        );
        this.drive = drive;
        this.gameContext = gameContext;
    }

    getDriveStats(drive, gameContext, gameStats) {
        const { gameConfig } = gameContext;

        const homeScore = this.drivePointsSummary(
            gameStats.filter(
                (gs) =>
                    gs.driveId === drive.id &&
                    gs.teamId === gameContext.homeTeamId
            ),
            gameConfig.scoring
        );

        const awayScore = this.drivePointsSummary(
            gameStats.filter(
                (gs) =>
                    gs.driveId === drive.id &&
                    gs.teamId === gameContext.awayTeamId
            ),
            gameConfig.scoring
        );

        return {
            homeScore,
            awayScore
        };
    }

    /**
     * Sum the points a set of drive-scoped stats is worth. Each scoring
     * category is counted from its dedicated stat record (a touchdown play
     * also flags `touchdowns` on its pass/rush/down stats, so those flags
     * must not be counted). Fallback values cover persisted game configs
     * predating a scoring key.
     * @param {FootballStats[]} driveStats stats of one team on one drive
     * @param {{[p:string]: number}} scoring gameConfig.scoring
     * @returns {number}
     */
    drivePointsSummary(driveStats, scoring) {
        return driveStats.reduce((points, stat) => {
            const values = stat.values || {};
            const rougePoints = values.rouge
                ? (values.rouge === true ? 1 : values.rouge) *
                  (scoring.rougePoints || 1)
                : 0;

            switch (stat.category) {
                case FootballStatsCategory.TOUCHDOWN:
                    return points + (values.completed ? scoring.touchdown : 0);
                case FootballStatsCategory.FIELD_GOAL:
                    if (values.completed) {
                        points += values.dropKick
                            ? scoring.dropKickFieldGoal || scoring.fieldGoal
                            : scoring.fieldGoal;
                    }
                    return points + rougePoints;
                case FootballStatsCategory.KICK_OFF:
                    return points + rougePoints;
                case FootballStatsCategory.DEUCE:
                    return points + (values.completed ? scoring.deuce || 2 : 0);
                case FootballStatsCategory.SAFETY:
                    return (
                        points + (values.completed ? scoring.safety || 2 : 0)
                    );
                default:
                    return points + getSafeOrDefault(() => values.points, 0);
            }
        }, 0);
    }

    toJSON() {
        return {
            drive: this.drive,
            ...super.toJSON(),
            ...this.getDriveStats(this.drive, this.gameContext, this.statLogs)
        };
    }
}
